<template>
  <section class="news-section" id="tin-tuc">
    <div class="news-container">
      <div class="news-header">
        <h2 class="news-title">Tin Tức Mới Nhất</h2>
        <p class="news-desc">
          Cập nhật những thông tin mới nhất về thị trường và hoạt động lễ hội.
        </p>
      </div>

      <div class="news-grid">
        <!-- News Card 1 -->
        <article class="news-card group">
          <div class="news-img-wrapper">
            <img alt="Market News" class="news-img"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuCpiHpgI9Re4KD0Rb7bd9rb98VOosfex4thYixAGu64SbZYIUyTLgK3H6mDykrPsohnECpOdxxE7-4LrqfPz5kHP4IFIRQKu8mWnbSeUNN9YXtW0eUOLqIMjRdaaEXk-_a-th8C-JbOlNdz5aHlGMIPUt-VKzFLgKUvPCgTUW8Tgk5LJwET8fQZSf6vdVkxrRXPpWQmTYE9n7mds1m1_49JE9d7VOgh752TSigZNq0Xz_OgHBvsS3Pli8CRBxSrRCUOENezkin9jkR0" />
          </div>
          <div class="news-content">
            <span class="news-meta">Thị trường | 10.10.2024</span>
            <h3 class="news-card-title">
              Xoài Cát Chu Đồng Tháp chính thức lên kệ hệ thống siêu thị Châu Âu
            </h3>
            <p class="news-card-excerpt">
              Bước tiến quan trọng giúp nông sản vùng Đất Sen Hồng khẳng định vị thế trên trường quốc tế...
            </p>
            <a href="#" class="news-read-more">
              Xem chi tiết
              <span class="isax isax-arrow-right-1 icon-small"></span>
            </a>
          </div>
        </article>

        <!-- News Card 2 -->
        <article class="news-card group">
          <div class="news-img-wrapper">
            <img alt="Sustainability" class="news-img"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuDyJ79F9R_R2_0li4yme_DXjWf-LH0JefR6uYdQMTPtMSOw1JApcupplJ7XFxTeml_R7h4HpmZQrODpJEgpWCoj2IIPwTpSpYY6FuGxzVn22WNkLwsLelZp9gbHi7zjH73VG1Rd1y2CG9wxTWmgdrzZkCNvbhCPiq7zjJwJlE_lc5EEdV37ta3atnXTzZt5TUYinlMSkXqHcAyQY5J3Jl8fvhfE23SOt2zNkj92GlCvoLF8lWvO7V18T6Frghs3JryYwKbCyLgNBewZ" />
          </div>
          <div class="news-content">
            <span class="news-meta">Môi trường | 08.10.2024</span>
            <h3 class="news-card-title">
              Mô hình du lịch sinh thái miệt vườn gắn liền với bảo tồn đa dạng sinh học
            </h3>
            <p class="news-card-excerpt">
              Đồng Tháp hướng tới phát triển bền vững, kết hợp hài hòa giữa kinh tế và bảo vệ môi trường...
            </p>
            <a href="#" class="news-read-more">
              Xem chi tiết
              <span class="isax isax-arrow-right-1 icon-small"></span>
            </a>
          </div>
        </article>

        <!-- News Card 3 -->
        <article class="news-card group">
          <div class="news-img-wrapper">
            <img alt="Community" class="news-img"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuC1N7ZRMt5RUq6q705lCJ57XOaspuFJ7pwGSioBDAhTt8RaXgT0tXn2oQ_NQNi-cGohjYUW7gDirIXR81bMNRmUmbsWYarDNE9IPd7jvP2FqpB9H2Ltc3RWOAAzztylywlf9eXVjBX4UNv4hiU59sY7tX9L_Ik56BA53LZN0b20BCV2dAc9DtXEIqsvbsK1a7crVNCmi3CQ9HP392RBnpPh0iAdkB4HGvqDm5o6mfhPv3icn43VfplV_OW1J_gfVE6zV_xv4ljhZLdX" />
          </div>
          <div class="news-content">
            <span class="news-meta">Cộng đồng | 05.10.2024</span>
            <h3 class="news-card-title">
              Người nông dân hào hứng chuẩn bị cho ngày hội lớn nhất năm
            </h3>
            <p class="news-card-excerpt">
              Không khí chuẩn bị rộn ràng khắp các nhà vườn, hứa hẹn một kỳ lễ hội thành công rực rỡ...
            </p>
            <a href="#" class="news-read-more">
              Xem chi tiết
              <span class="isax isax-arrow-right-1 icon-small"></span>
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TinTucMoiNhat"
}
</script>

<style scoped>
.news-section {
  padding: 80px 0;
  background-color: var(--color-public-surface, #f7fbf0);
}

.news-container {
  max-width: var(--container-max, 1280px);
  margin: 0 auto;
  padding: 0 var(--spacing-gutter, 24px);
}

.news-header {
  text-align: center;
  margin-bottom: 64px;
}

.news-title {
  font-family: var(--font-heading, "Montserrat");
  font-size: var(--text-headline-md-size, 32px);
  font-weight: 600;
  color: var(--color-public-text-head, #1B5E20);
  margin-bottom: 16px;
}

.news-desc {
  font-family: var(--font-body, "Inter");
  font-size: var(--text-body-md-size, 16px);
  color: var(--color-public-text-body, #40493d);
}

.news-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-gutter, 24px);
}

@media (min-width: 768px) {
  .news-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.news-card {
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid var(--outline-variant, #bfcaba);
  transition: box-shadow 0.3s ease;
}

.news-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.news-img-wrapper {
  height: 224px;
  overflow: hidden;
}

.news-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.news-card:hover .news-img {
  transform: scale(1.05);
}

.news-content {
  padding: 24px;
}

.news-meta {
  display: block;
  font-family: var(--font-body, "Inter");
  font-size: var(--text-label-sm-size, 12px);
  color: var(--color-public-primary, #0d631b);
  font-weight: 700;
  margin-bottom: 8px;
}

.news-card-title {
  font-family: var(--font-body, "Inter");
  font-size: var(--text-body-lg-size, 18px);
  font-weight: 700;
  color: #181d17;
  line-height: 1.4;
  margin: 0 0 12px 0;
  transition: color 0.3s ease;
}

.news-card:hover .news-card-title {
  color: var(--color-public-primary, #0d631b);
}

.news-card-excerpt {
  font-family: var(--font-body, "Inter");
  font-size: var(--text-body-sm-size, 14px);
  color: var(--color-public-text-body, #40493d);
  margin: 0 0 16px 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-read-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-body, "Inter");
  font-size: var(--text-label-lg-size, 14px);
  font-weight: 700;
  color: var(--color-public-primary, #0d631b);
  text-decoration: none;
}

.news-read-more:hover {
  text-decoration: underline;
}

.icon-small {
  font-size: 18px;
  display: inline-block;
  vertical-align: middle;
}
</style>